<template>
	<button :disabled="booking.checked_in" @click="$emit('click')">{{ eventName }} - {{ eventTime }}</button>
</template>

<script>
	import moment from 'moment';

	export default {
		props: {
			booking: {
				required: true,
			}
		},

		computed: {
			eventName: function () {
				return this.booking.event_name;
			},

			eventTime: function () {
				if (!this.booking.event_start) {
					return null;
				}

				return moment(this.booking.event_start).format('Do @ HH:mma');
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/BookingButtonComponent.vue